var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"budget-bar"},[_c('div',{staticClass:"filled",class:{ overflow: _vm.overflow },style:({ width: _vm.fillWidth })}),_c('div',{staticClass:"remainder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }